// extracted by mini-css-extract-plugin
var _1 = "VerificationVerifiersFields-module__animatedBackground--d4uKD";
var _2 = "VerificationVerifiersFields-module__avatarsWrapper--OTBET";
var _3 = "VerificationVerifiersFields-module__editPrimary--jfLVV";
var _4 = "VerificationVerifiersFields-module__empty--OBfY4";
var _5 = "VerificationVerifiersFields-module__primarySelect--XeWna";
var _6 = "VerificationVerifiersFields-module__secondVerifier--STVrq";
var _7 = "VerificationVerifiersFields-module__secondarySelect--Od6vY";
var _8 = "VerificationVerifiersFields-module__userInput--yKyxS";
var _9 = "VerificationVerifiersFields-module__verifiers--mm9UP";
var _a = "VerificationVerifiersFields-module__verifiersItem--XyKii";
var _b = "VerificationVerifiersFields-module__verifiersTitle--ACKfn";
var _c = "VerificationVerifiersFields-module__warning--mNk0V";
export { _1 as "animatedBackground", _2 as "avatarsWrapper", _3 as "editPrimary", _4 as "empty", _5 as "primarySelect", _6 as "secondVerifier", _7 as "secondarySelect", _8 as "userInput", _9 as "verifiers", _a as "verifiersItem", _b as "verifiersTitle", _c as "warning" }
